import { useCallback } from 'react';

import { AuthFormContext } from '@webapp/account/src/components/auth/context';
import type { AuthStore } from '@webapp/account/src/components/auth/useAuthFormStore';
import { useAuthStore } from '@webapp/account/src/components/auth/useAuthFormStore';

export const AuthForm: FC<{
    onSubmit?: (store: AuthStore) => void;
    children?: ReactNode;
}> = ({ children, onSubmit }) => {
    const store = useAuthStore();

    const handleSubmit = useCallback(
        (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            onSubmit && onSubmit(store);
        },
        [onSubmit, store],
    );

    return (
        <AuthFormContext.Provider value={store}>
            <form onSubmit={handleSubmit}>{children}</form>
        </AuthFormContext.Provider>
    );
};
